export const DEFAULT_ACTION_SOURCE = 'ReadingPane';
